<template>
  <div class="coin-amount">
    <i></i>
    <strong>{{ num }}</strong>
  </div>
</template>

<script>
export default {
  name: 'Coin',
  props: {
    num: {
      type: [Number, String],
      default: 0
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/css/style.scss";
.coin-amount {
  @include center();
  color: #F9912A;
  i{
    width: px2rem(40);
    height: px2rem(40);
    background-image: url("../../assets/image/recharge/coin.svg");
    background-size: 100% 100%;
  }
  strong{
    font-size: px2rem(40);
    margin: 0 px2rem(4);
  }

}
</style>
